export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_EMPTY = 'CART_EMPTY';

export const CART_SAVE_SHIPPING_DETAILS = 'CART_SAVE_SHIPPING_DETAILS';
export const CART_SAVE_BILLING_INFO = 'CART_SAVE_BILLING_INFO';
